import { Component, OnInit } from '@angular/core'
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-custact-dead-lines',
  templateUrl: './custact-dead-lines.component.html',
  styleUrls: ['./custact-dead-lines.component.css']
})
export class CustactDeadLinesComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public itemsListDeadLines: Item[] = [];

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(3344, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadDeadLines() {
        this.itemsListDeadLines = await this.datatask.Post(1012);
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_custactdeadlines.grid')
                .setLoadDataFunction({
                    method: 3343,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'custactdeadline_new',
                    text: 'custactdeadline_new',
                    func: () => this.stateService?.go('custactedit', {
                        custact_no: '0',
                        filterfield: this.argType,
                        filtervalue: this.argValue
                    }),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'custactedit':
                this.stateService?.go('custactedit', {
                    custact_no: '0',
                    filterfield: this.argType,
                    filtervalue: this.argValue
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadSetting();
        this.loadDeadLines();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    show_setting: string;
    show_grid: string;
}
